module.exports = "/_next/static/images/d61ac8e15bf2e2f22a9b1195dd415d2c-xpeer-fgts@3x.jpg";